import useTranslation from 'next-translate/useTranslation';
import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import { useStripeCtx } from '../../context/stripeContext';

interface Props {
  className?: string;
  disable?: boolean;
}

const CardInput = ({ className, disable = false }: Props): JSX.Element => {
  const { t } = useTranslation();

  const { stripeCard, stripeError, setElementsLoaded, enableCardInput, disableCardInput } = useStripeCtx();

  useEffect(() => {
    setElementsLoaded(true);
  }, []);

  useEffect(() => {
    disable && disableCardInput();
    !disable && enableCardInput();
  }, [disable]);

  return (
    <div className="stripe-card-container">
      <em className="info-ico card-info-ico" data-tip data-for="cardInput" onClick={(e) => e.stopPropagation()} />
      <label className={className ?? ''}>
        <span className="info-label">{t('common:form.payment_card')}</span>
        <ReactTooltip id="cardInput" place="top" effect="solid" className="dramox-tooltip" isCapture>
          {t('common:form.card_tooltip')}
        </ReactTooltip>
        <div ref={stripeCard} className="stripe-card" />
        <span ref={stripeError}></span>
      </label>
    </div>
  );
};

export default CardInput;
